import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody28';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy28 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'> Comprehensive Business Plan  </h2><h4>and a go-to-market strategy for a fintech company</h4>";

  return (
    <>
        <Helmet>
        <title>Comprehensive Business Plan and a go-to-market strategy for a fintech company</title>
        <meta property="og:title" content="Comprehensive Business Plan and a go-to-market strategy for a fintech company" />
        <meta property='og:description' content='Comprehensive Business Plan and a go-to-market strategy for a fintech company'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy28" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy28
